import { render, staticRenderFns } from "./facturascv.vue?vue&type=template&id=9e77f3e0"
import script from "./facturascv.vue?vue&type=script&lang=js"
export * from "./facturascv.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports